export default "__VITE_ASSET__k2ZuOK9j__"